export const hmsConstants = {
  // hms client token
  GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_REQUEST:
    "GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_REQUEST",
  GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_SUCCESS:
    "GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_SUCCESS",
  GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_FAILURE:
    "GET_GENERATED_HMS_CLIENT_TOKEN_ACTION_FAILURE",

  //hms room details
  GET_HMS_ROOM_DETAILS_ACTION_REQUEST: "GET_HMS_ROOM_DETAILS_ACTION_REQUEST",
  GET_HMS_ROOM_DETAILS_ACTION_SUCCESS: "GET_HMS_ROOM_DETAILS_ACTION_SUCCESS",
  GET_HMS_ROOM_DETAILS_ACTION_FAILURE: "GET_HMS_ROOM_DETAILS_ACTION_FAILURE",

  //hms room details
  CREATE_HMS_ROOM_QUESTION_ACTION_REQUEST:
    "CREATE_HMS_ROOM_QUESTION_ACTION_REQUEST",
  CREATE_HMS_ROOM_QUESTION_ACTION_SUCCESS:
    "CREATE_HMS_ROOM_QUESTION_ACTION_SUCCESS",
  CREATE_HMS_ROOM_QUESTION_ACTION_FAILURE:
    "CREATE_HMS_ROOM_QUESTION_ACTION_FAILURE",

  //hms room details
  UPDATE_HMS_ROOM_QUESTION_ACTION_REQUEST:
    "UPDATE_HMS_ROOM_QUESTION_ACTION_REQUEST",
  UPDATE_HMS_ROOM_QUESTION_ACTION_SUCCESS:
    "UPDATE_HMS_ROOM_QUESTION_ACTION_SUCCESS",
  UPDATE_HMS_ROOM_QUESTION_ACTION_FAILURE:
    "UPDATE_HMS_ROOM_QUESTION_ACTION_FAILURE",

  //hms room details
  DELETE_HMS_ROOM_QUESTION_ACTION_REQUEST:
    "DELETE_HMS_ROOM_QUESTION_ACTION_REQUEST",
  DELETE_HMS_ROOM_QUESTION_ACTION_SUCCESS:
    "DELETE_HMS_ROOM_QUESTION_ACTION_SUCCESS",
  DELETE_HMS_ROOM_QUESTION_ACTION_FAILURE:
    "DELETE_HMS_ROOM_QUESTION_ACTION_FAILURE",

  //hms room details
  GET_HMS_ROOM_QUESTION_ACTION_REQUEST: "GET_HMS_ROOM_QUESTION_ACTION_REQUEST",
  GET_HMS_ROOM_QUESTION_ACTION_SUCCESS: "GET_HMS_ROOM_QUESTION_ACTION_SUCCESS",
  GET_HMS_ROOM_QUESTION_ACTION_FAILURE: "GET_HMS_ROOM_QUESTION_ACTION_FAILURE",

  //hms room details
  CREATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST:
    "CREATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST",
  CREATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS:
    "CREATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS",
  CREATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE:
    "CREATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE",

  //hms room details
  UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST:
    "UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST",
  UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS:
    "UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS",
  UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE:
    "UPDATE_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE",

  //hms room details
  GET_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST:
    "GET_HMS_ROOM_QUESTION_RATING_ACTION_REQUEST",
  GET_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS:
    "GET_HMS_ROOM_QUESTION_RATING_ACTION_SUCCESS",
  GET_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE:
    "GET_HMS_ROOM_QUESTION_RATING_ACTION_FAILURE",
};
